import React from 'react';

export interface GhostAltSVGProps {
  width: number;
  height: number;
  style?: React.CSSProperties;
  className?: string;
  onClick?: () => void;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  onFocus?: () => void;
  onBlur?: () => void;
  onKeyDown?: (event: React.KeyboardEvent<SVGSVGElement>) => void;
}

/**
 * @component
 * A component that returns an SVG component that can be used with several of the components in this library.
 * Original SVG was CC0 (source: https://www.svgrepo.com/svg/400277/ghost)
 */
function GhostAltSVG({
  width,
  height,
  style = {},
  className = '',
  onClick,
  onMouseEnter,
  onMouseLeave,
  onFocus,
  onBlur,
  onKeyDown,
}: GhostAltSVGProps) {
  return (
    <svg
      width={`${width}`}
      height={`${height}`}
      style={style}
      viewBox="0 0 72 72"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      aria-hidden="true"
      role="img"
      className={`iconify iconify--fxemoji ${className}`}
      preserveAspectRatio="xMidYMid meet"
      onClick={onClick}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onFocus={onFocus}
      onBlur={onBlur}
      onKeyDown={onKeyDown}
    >
      <path
        fill="#D1CFC3"
        d="M22.541 39.677c-8.687 0-16.824-3.548-21.238-9.26a5.384 5.384 0 1 1 8.519-6.584c2.383 3.083 7.375 5.075 12.72 5.075a5.385 5.385 0 0 1-.001 10.769zm48.323-9.26a5.384 5.384 0 1 0-8.519-6.584c-2.383 3.083-7.375 5.075-12.72 5.075a5.383 5.383 0 1 0 0 10.768c8.687.001 16.825-3.546 21.239-9.259z"
      />
      <path
        fill="#E5E4DF"
        d="M60.38 68.154a4.633 4.633 0 0 1-3.438 1.429c-1.786 0-3.454-.941-4.462-2.513c-.562-.874-1.437-1.383-2.399-1.397c-.925.013-1.797.522-2.359 1.397c-1.026 1.597-2.652 2.513-4.462 2.513h-.117c-1.786 0-3.454-.941-4.462-2.513c-.562-.874-1.437-1.383-2.399-1.397c-.925.013-1.797.522-2.359 1.397c-1.026 1.597-2.655 2.513-4.465 2.513a.735.735 0 0 0-.115 0c-1.786 0-3.454-.941-4.462-2.513c-.562-.874-1.437-1.383-2.399-1.397c-.925.013-1.799.522-2.359 1.394c-1.026 1.599-2.655 2.516-4.465 2.516c-.075 0-.152-.008-.227-.024c-1.303-.056-2.431-.576-3.212-1.405c-.608-.642-1.309-1.783-1.205-3.577c.138-2.402 4.829-40.319 5.078-42.323c.057-11.085 9.087-20.086 20.186-20.086c11.097 0 20.129 8.999 20.188 20.083c.247 1.986 4.98 39.921 5.118 42.326c.105 1.794-.596 2.937-1.204 3.577z"
      />
      <path
        fill="#2B3B47"
        d="M29.464 22.523v3.656h-.005c0 .005.005.007.005.01a2.602 2.602 0 0 1-5.202 0v-.01h-.011v-3.656h.031a2.595 2.595 0 0 1 2.581-2.38a2.59 2.59 0 0 1 2.575 2.38h.026zm18.708-1.126c-.181-2.103-1.921-3.758-4.066-3.758c-2.151 0-3.892 1.655-4.075 3.758h-.049v5.773H40v.016c0 2.267 1.84 4.107 4.107 4.107s4.107-1.84 4.107-4.107c0-.004-.009-.007-.009-.016h.009v-5.773h-.042zm1.607 12.514c-.052-.101-.129-.181-.239-.193c-1.108-.11-25.417-.106-26.522 0a.299.299 0 0 0-.139.057c-.006.004-.014.003-.02.008a.39.39 0 0 0-.082.51l.241.386a18.612 18.612 0 0 0 1.658 2.262a20.765 20.765 0 0 0 1.659 1.728c1.101 1.022 2.213 1.766 3.315 2.412c.45.264.655.324.906.43c.018-.013.046-.024.065-.036c1.796.874 3.725 1.375 5.746 1.375c1.982 0 3.876-.482 5.643-1.324l.004.002c.298-.138.597-.258.898-.423c1.104-.637 2.209-1.39 3.314-2.414a19.706 19.706 0 0 0 1.655-1.737a18.424 18.424 0 0 0 1.66-2.274l.241-.388a.405.405 0 0 0 .056-.177a.369.369 0 0 0-.059-.204z"
      />
      <path
        fill="#FF473E"
        d="M42.35 33.637v7.606c0 3.358-2.716 6.081-6.066 6.081a6.078 6.078 0 0 1-6.077-6.081v-7.606H42.35z"
      />
      <path
        fill="#2B3B47"
        d="M29.619 36.086v-.831c0-2.12-5.67-1.618 6.228-1.618s7.091-.503 7.091 1.618v.831H29.619zm7.601 8.151v-6.396a.941.941 0 0 0-1.882 0v6.396a.942.942 0 0 0 1.882 0z"
      />
    </svg>
  );
}

export { GhostAltSVG };
